import { call, put, takeLatest } from "redux-saga/effects";
import {
  GeneralUtilsAction,
  InitAction,
  PettyCashierMonthlyReviewAction
} from "../../actions";
import * as types from "../../actions/actionTypes";
import * as monthlyReviewApi from "../../api/monthlyReview/pettyCashierMonthlyReview";
import GetFilter from "../../containers/monthlyReports/filter/tools/getFilter";
import { SetMessage } from "../../assets/errorMessages";
import { PAYMENT, RECEIVE } from "../../constants/accountReviewTypes";
import * as paymentApi from "../../api/payment/pettyCashierPayment";
import * as receiveApi from "../../api/receive/pettyCashierReceive";
import { toastr } from "react-redux-toastr";
import { createBrowserHistory } from "history";
import { PAGE_NUM } from "../../constants/filters";

export function* pettyCashierWatcherMonthlyReview() {
  yield takeLatest(types.PETTY_CASHIER_GET_MONTHLY_REVIEW_REQUEST, worker);
  yield takeLatest(
    types.PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_REQUEST,
    workerDetail
  );
  yield takeLatest(
    types.PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_REQUEST,
    remove
  );
  yield takeLatest(
    types.PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_REQUEST,
    workerShowByAccountTitles
  );
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return monthlyReviewApi.getList(page_number, GetFilter());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(PettyCashierMonthlyReviewAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierMonthlyReviewAction.getFailure(message));
  }
}

async function fetchListDetail(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return monthlyReviewApi.getDetailList(page_number, GetFilter());
}

function* workerDetail(action) {
  try {
    const response = yield call(fetchListDetail, action.pageNumber);
    yield put(PettyCashierMonthlyReviewAction.getDetailSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierMonthlyReviewAction.getDetailFailure(message));
  }
}

async function removeRequest(id, account_type) {
  if (account_type === PAYMENT) {
    return paymentApi.remove(id);
  } else if (account_type === RECEIVE) {
    return receiveApi.remove(id);
  }
}

function* remove(action) {
  try {
    const response = yield call(removeRequest, action.id, action.account_type);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const responseReq = yield call(fetchListDetail, action.pageNumber);
    const history = createBrowserHistory();
    const urlParams = new URLSearchParams(window.location.search);
    const pNum = urlParams.get(PAGE_NUM);
    if (pNum !== action.pageNumber) {
      urlParams.set(PAGE_NUM, action.pageNumber);
      history.push({ search: urlParams.toString() });
    }
    yield put(PettyCashierMonthlyReviewAction.removeSuccess(responseReq.data));
    yield put(GeneralUtilsAction.closeConfirmForTable());
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierMonthlyReviewAction.removeFailure());
  }
}

async function fetchShowByAccountTitles(filters, pageNumber) {
  return monthlyReviewApi.showByAccountTitles(pageNumber, GetFilter(filters));
}

function* workerShowByAccountTitles(action) {
  try {
    const response = yield call(
      fetchShowByAccountTitles,
      action.filters,
      action.pageNumber
    );
    yield put(
      PettyCashierMonthlyReviewAction.showByAccountTitlesSuccess(response.data)
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(
      PettyCashierMonthlyReviewAction.showByAccountTitlesFailure(message)
    );
  }
}
